import { getServiceUrl } from './api.config';
import { ApiClientOptions } from './types/api';
import ApiClient from './utils/ApiClient';
import { isPositiveInteger, isString } from './utils/validators';

export default class PublicApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('public'), options);
  }

  public getProduct(queries: any = {}, useCache: boolean = true) {
    const query = '/public/v1/hpp/product/private';
    let parameters = '?alk=1';
    if (isString(queries.gtin)) {
      parameters += `&filter_gtins_in=${queries.gtin}`;
    } else if (isPositiveInteger(queries.productVersionId)) {
      parameters += `&version_id=${queries.productVersionId}`;
    }
    parameters += `&organization_id=${queries.organizationId}`;

    return this.get(query, parameters, useCache);
  }
}
